import type { SiteLogo } from '@/navTree';

/** Fallback brand when top-nav API data is absent; keep aligned with NavSiteBrand.stories Default. */
export const defaultNavSiteBrandProps: {
  rootUrl: string;
  siteName: string;
  siteSubtitle: string;
  siteLogos: SiteLogo[];
} = {
  rootUrl: '/',
  siteName: 'INDMO I.P',
  siteSubtitle: 'Institutu Nacional ba Dezenvolvimentu',
  siteLogos: [],
};
